import { createI18n } from 'vue-i18n'

import { locales } from '@last/core-ui/paprika'

import ca from '@/locales/ca.json'
import de from '@/locales/de.json'
import en from '@/locales/en.json'
import es from '@/locales/es.json'

import 'moment/dist/locale/ca'
import 'moment/dist/locale/es'
import 'moment/dist/locale/de'

const availableLocales = ['en', 'es', 'ca', 'de']

export default createI18n({
  globalInjection: true,
  legacy: false,
  locale: 'es',
  fallbackLocale: 'es',
  availableLocales,
  messages: {
    en: {
      ...locales.en,
      ...en
    },
    es: {
      ...locales.es,
      ...es
    },
    ca: {
      ...locales.ca,
      ...ca
    },
    de: {
      ...locales.de,
      ...de
    }
  }
})
